<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm" :model="guaModel"
          :rules="modelValidate"
          label-position="right"
          :label-width="180">
          <div class="padding-top-20"></div>
          <Divider orientation="left">附件上传</Divider>

          <FormItem label="担保合同" prop="contractOssKeys" :rules="[{required:true,validator:arrayValidator,trigger:'blur'}]">
            <Upload
              ref="contractUploader"
              type="drag"
              :data="OSSParam"
              :before-upload="(file)=>handleBeforeUpload(file, 0)"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :format="['jpg','jpeg','pdf','png']"
              :on-progress="handleUploadProgress"
              :on-format-error="handleFormatError"
              :default-file-list="uploadedContractArray"
              :show-upload-list="false"
              :action="uploadParams.host">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload-outline" size="52"></Icon>
                <p>点击或拖拽上传附件</p>
              </div>
            </Upload>
            <div class="contract" v-if="uploadedContractArray && uploadedContractArray.length">
              <div class="contract-thumb" v-for="(item,upIdx) in uploadedContractArray" :key="upIdx">
                <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix?item.surfix.toUpperCase():''}}</span>
                <div class="contract-thumb-cover">
                  <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='image'" @click="handleImgPreview(uploadedContractArray, upIdx)"></Icon>
                  <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='file'" @click="previewImgUrl=item;showPreview=true"></Icon>
                  <Icon type="ios-trash-outline" @click="removeItem(item)"></Icon>
                </div>
              </div>
            </div>
          </FormItem>

          <FormItem :label="fileReq.name" :prop="`attachments[${getAttachmentIndex(idx)}].url`"
            v-for="(fileReq,idx) in fileRequirements"
            :key="idx"
            :rules="fileReq.isRequired?[{required:true,message:'必填',trigger:'blur'}]:null">
            <Upload
              type="drag"
              :data="OSSParam"
              :before-upload="(file)=>handleBeforeUpload(file, idx+1, fileReq.name, 3)"
              :multiple="false"
              :on-progress="handleUploadProgress"
              :on-success="handleUploadSuccess"
              :format="fileReq.formats!=='*'?fileReq.formats.split(','):[]"
              :on-format-error="handleFormatError"
              :show-upload-list="true"
              :action="uploadParams.host">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload-outline" size="52"></Icon>
                <p>点击或拖拽上传附件</p>
              </div>
            </Upload>
            <div class="contract" v-if="guaModel.attachments&&guaModel.attachments instanceof Array&&guaModel.attachments.length">
              <template v-if="currentFileRequirement(idx)&&currentFileRequirement(idx).urls&&(currentFileRequirement(idx).urls instanceof Array)&&currentFileRequirement(idx).urls.length">
                <div class="contract-thumb" v-for="(item,upIdx) in currentFileRequirement(idx).urls" :key="upIdx">
                  <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                  <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix?item.surfix.toUpperCase():''}}</span>
                  <div class="contract-thumb-cover">
                    <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='image'" @click="handleImgPreview(currentFileRequirement(idx).urls, upIdx)"></Icon>
                    <Icon type="ios-eye-outline" v-if="item&&item.url&&item.type==='file'" @click="previewImgUrl=item;showPreview=true"></Icon>
                    <Icon type="ios-trash-outline" @click="removeAttachmentItem(item,idx)"></Icon>
                  </div>
                </div>
              </template>
            </div>
          </FormItem>
          <div class="padding-top-20"></div>
        </Form>
        </vue-scroll>
      </div>

      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="4"><Button type="primary" ghost size="large" style="display:inline" long @click="backward">上一步</Button></Col>
          <Col span="16"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
          <Col span="4"><Button type="info" size="large" style="display:inline" long @click="draft">存草稿</Button></Col>
        </Row>
      </div>
      <Spin fix v-if="uploading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>上传中...{{uploadingProgress}}%</div>
      </Spin>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </div>
</template>

<script>
export default {
  name: 'guarantor-new-puyang-step3',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      guaModel: {
        contractOssKeys: [],
        attachments: []
      },
      modelValidate: {
      },
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      curOSSParamIndex: null,
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',
        signature: '',
        fileIndex: 0
      },
      uploadList: [],
      uploadedContractArray: [],
      previewImgUrl: null,
      showPreview: false,
      fileRequirements: [],
      fileRequirementsUploaded: [],
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0,
      uploading: false,
      uploadingProgress: 0,
      arrayValidator: (rule, value, callback) => {
        if (this.uploadedContractArray && this.uploadedContractArray.length > 0) {
          callback()
        } else {
          callback(new Error('请上传担保合同'))
        }
      }
    }
  },
  watch: {
  },
  mounted () {
    this.listFileRequirements()
    this.uploadList = this.$refs.contractUploader ? this.$refs.contractUploader.fileList : []
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    backward () {
      this.$emit('go-backward')
    },
    getAttachmentIndex (idx) {
      let name = this.fileRequirements[idx].name
      return this.guaModel.attachments.findIndex(o => o.name === name)
    },
    currentFileRequirement (idx) {
      if (!this.fileRequirements[idx]) return null
      let name = this.fileRequirements[idx].name
      return this.guaModel.attachments.find(o => o.name === name)
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve, reject) => {
        try {
          let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
          if (surfix.indexOf('?')) {
            surfix = surfix.substring(0, surfix.indexOf('?'))
          }
          let type = 'image'
          switch (surfix) {
            case 'jpg':
              type = 'image'
              break
            case 'jpeg':
              type = 'image'
              break
            case 'png':
              type = 'image'
              break
            case 'gif':
              type = 'image'
              break
            case 'pdf':
              type = 'file'
              break
            case 'doc':
              type = 'file'
              break
            case 'docx':
              type = 'file'
              break
            case 'xls':
              type = 'file'
              break
            case 'xlsx':
              type = 'file'
              break
            case 'ppt':
              type = 'file'
              break
            case 'pptx':
              type = 'file'
              break
            default:
              type = 'file'
              break
          }
          let obj = {
            name: k,
            url,
            type,
            surfix
          }
          console.log(obj)
          resolve(obj)
          return obj
        } catch (er) {
          reject(er)
        }
      })
    },
    procOssKeys (keys) {
      keys.forEach(async (k) => {
        try {
          if (typeof(k) === 'string') {
            let keyObj = await this.procOssKey(k)
            this.uploadedContractArray.push({
              name: keyObj.name,
              url: keyObj.url,
              key: keyObj.name,
              type: keyObj.type,
              surfix: keyObj.surfix
            })
          } else if (typeof(k) === 'object' && k.url) {
            this.uploadedContractArray.push({
              name: k.name,
              url: k.url,
              key: k.name,
              type: k.type,
              surfix: k.surfix
            })
          }
        } catch (e) {
          console.log(e)
        }
      })
      this.$nextTick(() => {
        this.uploadList = this.$refs.contractUploader.fileList
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        this.$Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    async listFileRequirements () {
      try {
        let res = await this.$Api.Guarantee.listFileRequirements({
          variety: this.data.variety,
          cityId: this.data.cityId,
          industryId: this.data.industryId
        }, 1, 100)
        this.fileRequirements = res.data || []
        // If joint guarantee mode, add joint contract as required attachment
        if (this.data.gMethod === 2) {
          this.fileRequirements.unshift({
            name: '联保合同',
            formats: 'jpg,jpeg,png,pdf',
            maxLength: 10,
            fileCountLimit: 1,
            isRequired: true,
            type: 3
          })
        }
        // Initialize attachments array
        this.fileRequirements.forEach((f) => {
          let existAtt = this.guaModel.attachments.find(o => o.name === f.name)
          if (!existAtt) {
            this.guaModel.attachments.push({
              name: f.name,
              formats: f.formats,
              maxLength: f.maxLength,
              fileCountLimit: f.fileCountLimit,
              isRequired: f.isRequired,
              url: '',
              urls: []
            })
          } else {
            existAtt.formats = f.formats
            existAtt.maxLength = f.maxLength
            existAtt.fileCountLimit = f.fileCountLimit
            existAtt.isRequired = f.isRequired
          }
        })
        // If editing existing data
        if (this.data.attachments && this.data.attachments.length) {
          this.data.attachments.forEach(att => {
            let exist = this.guaModel.attachments.find(o => o.name === att.name)
            if (exist) {
              exist.urls = []
              let urls = att.url ? att.url.split(',') : []
              this.$nextTick(() => {
                exist.url = att.url
                urls.forEach(async (u) => {
                  let itemUrl = u
                  if (u.indexOf('oss:') === 0) {
                    itemUrl = await this.procOssKey(u)
                    this.$nextTick(() => {
                      exist.urls.push(itemUrl)
                      this.$nextTick(() => {})
                    })
                  }
                })
              })
            }
          })
        }
        if (this.data.contractOssKeys && this.data.contractOssKeys.length) {
          this.procOssKeys(this.data.contractOssKeys)
          // this.uploadedContractArray = this.data.contractOssKeys.map(u => {
          //   return {
          //     name: u.substring(u.lastIndexOf('/') + 1),
          //     url: u,
          //     status: 'finished'
          //   }
          // })
        }
      } catch (err) {
        this.$Message.error('获取文件上传要求失败!' + err.message)
      }
    },
    async getOSSParams (index, name, fileType) {
      try {
        let res = await this.$Api.Guarantee.getUploadParams(fileType || 1)
        this.uploadParams = res
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index
        let paramKey = this.uploadParams.dir ? this.uploadParams.dir : ''
        this.OSSParam = {
          name: name || '',
          key: paramKey,
          policy: this.uploadParams.policy,
          OSSAccessKeyId: this.uploadParams.accessid,
          success_action_status: '200',
          signature: this.uploadParams.signature,
          fileIndex: index
        }
        return Promise.resolve(this.OSSParam)
      } catch (err) {
        this.$Message.error('获取上传参数失败!' + err.message)
        return Promise.reject(err)
      }
    },
    async handleBeforeUpload (file, index, name, fileType) {
      await this.getOSSParams(index, name, fileType)
      let key = this.OSSParam.key
      if (!key) {
        this.$Message.error('请先获取上传参数')
        return false
      }
      let filename = key + this.randomString(10) + '.' + this.getSuffix(file.name)
      this.OSSParam.key = filename
      return true
    },
    handleUploadProgress (event) {
      let percent = event.percent
      this.uploadingProgress = Math.round(percent * 100) / 100
    },
    handleFormatError () {
      this.$Message.warning('文件格式不正确')
    },
    handleUploadSuccess (res, file) {
      let key = this.OSSParam.key
      if (!key) return
      let url = this.uploadParams.host + '/' + key
      let fileSuffix = this.getSuffix(file.name)
      let type = ['jpg', 'jpeg', 'png', 'bmp', 'gif'].indexOf(fileSuffix.toLowerCase()) >= 0 ? 'image' : 'file'

      if (this.OSSParam.fileIndex === 0) {
        // Contract file
        let existIndex = this.uploadedContractArray.findIndex(o => o.name === file.name)
        if (existIndex >= 0) {
          this.uploadedContractArray.splice(existIndex, 1)
        }
        this.uploadedContractArray.push({
          name: file.name,
          url: url,
          key: 'oss:' + key,
          type: type,
          surfix: fileSuffix
        })
        this.$refs.contractUploader.fileList = []
      } else {
        // Attachment files
        let idx = this.OSSParam.fileIndex - 1
        let fileReq = this.fileRequirements[idx]
        if (fileReq) {
          let att = this.guaModel.attachments.find(o => o.name === fileReq.name)
          if (!att) {
            att = {
              name: fileReq.name,
              formats: fileReq.formats,
              maxLength: fileReq.maxLength,
              fileCountLimit: fileReq.fileCountLimit,
              isRequired: fileReq.isRequired,
              url: '',
              urls: []
            }
            this.guaModel.attachments.push(att)
          }
          att.urls.push({
            name: 'oss:' + key,
            url: url,
            type: type,
            surfix: fileSuffix
          })
          let urlArr = att.urls.map((u) => {
            return u.name
          })
          if (urlArr.length) {
            att.url = urlArr.join(',')
          }
        }
      }
      this.uploading = false
      this.uploadingProgress = 0
    },
    handleImgPreview (fileList, index) {
      this.imageUrls = fileList.filter(f => f.type === 'image').map(f => f.url)
      this.startPosition = index
      this.visiblePreviewer = true
    },
    removeItem (item) {
      let idx = this.uploadedContractArray.findIndex(o => o.name === item.name)
      if (idx >= 0) {
        this.uploadedContractArray.splice(idx, 1)
      }
    },
    removeAttachmentItem (item, idx) {
      let fileReq = this.fileRequirements[idx]
      if (!fileReq) return
      let att = this.guaModel.attachments.find(o => o.name === fileReq.name)
      if (!att || !att.urls) return
      let uidx = att.urls.findIndex(o => o.name === item.name)
      if (uidx >= 0) {
        att.urls.splice(uidx, 1)
      }
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      if (pos > 0) {
        return filename.substring(pos + 1)
      }
      return ''
    },
    randomString (len) {
      len = len || 32
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let maxPos = chars.length
      let pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    async submit () {
      this.$refs.newForm.validate((valid) => {
        if (valid) {
          // Build contractOssKeys
          this.guaModel.contractOssKeys = this.uploadedContractArray.map(u => u.key)
          this.$emit('finish-step3', this.guaModel)
        }
      })
    },
    async draft () {
      this.guaModel.contractOssKeys = this.uploadedContractArray.map(u => u.key)
      let draft = JSON.parse(JSON.stringify(this.guaModel))
      draft.cityId = this.data.cityId
      draft.industryId = this.data.industryId
      draft.variety = this.data.variety
      draft.project = this.data.project
      draft.owner = this.data.owner
      draft.contractor = this.data.contractor
      if (this.data.id) {
        draft.id = this.data.id
      }
      if (this.data.prjId) draft.prjId = this.data.prjId
      if (this.data.ownerId) draft.ownerId = this.data.ownerId
      if (this.data.contractorId) draft.contractorId = this.data.contractorId
      if (!draft.guarantorId) {
        draft.guarantorId = this.$store.getters.guarantorInfo.id
      }
      // Include amounts from step2
      draft.amount = this.data.amount
      draft.fee = this.data.fee
      draft.counterCash = this.data.counterCash
      draft.counterMortgage = this.data.counterMortgage
      draft.counter3rdparty = this.data.counter3rdparty
      draft.counterOther = this.data.counterOther
      draft.amountCostRatio = this.data.amountCostRatio
      draft.counterRatio = this.data.counterRatio
      draft.gMethod = this.data.gMethod
      draft.gStartDate = this.data.gStartDate
      draft.gEndDate = this.data.gEndDate
      draft.gFeeRate = this.data.gFeeRate
      draft.beneficiary = this.data.beneficiary
      draft.beneficiaryAddress = this.data.beneficiaryAddress
      draft.beneficiaryBusinessLicense = this.data.beneficiaryBusinessLicense
      draft.guaranteed = this.data.guaranteed
      draft.guaranteedBusinessLicense = this.data.guaranteedBusinessLicense
      draft.opName = this.data.opName
      draft.opContactTel = this.data.opContactTel
      draft.jointGuarantors = this.data.jointGuarantors
      this.$Spin.show()
      this.$Api.Guarantee.draftGuarantee(draft).then(() => {
        this.$Message.success('操作成功')
        this.$Spin.hide()
        this.$router.push('/guarantees/list')
      }).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {
  }
}
.contract {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .contract-thumb {
    width: 120px;
    height: 120px;
    margin-right: 10px;
    position: relative;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 24px;
    }
    .contract-thumb-cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      display: none;
      align-items: center;
      justify-content: center;
      color: #fff;
      i {
        font-size: 24px;
        margin: 0 5px;
        cursor: pointer;
      }
    }
    &:hover .contract-thumb-cover {
      display: flex;
    }
  }
}
.demo-spin-icon-load {
  animation: demo-spin-icon-load 1s linear infinite;
}
@keyframes demo-spin-icon-load {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>